import React from 'react';
import { useTranslation } from 'react-i18next';
import { List } from '@mui/material';
import LinkListItem from './LinkListItem';
import { DeliveryRequestIcon, EditIcon, WarehouseItemIcon, } from '../atoms/Icons';
var WarehouseMenuList = function (_a) {
    var onClick = _a.onClick;
    var t = useTranslation().t;
    return (React.createElement(List, null,
        React.createElement(LinkListItem, { href: '/warehouse', icon: React.createElement(DeliveryRequestIcon, null), text: t('pages.deliveryRequests.title'), onClick: onClick }),
        React.createElement(LinkListItem, { href: '/warehouse/items', icon: React.createElement(WarehouseItemIcon, null), text: t('pages.warehouseItems.title'), onClick: onClick }),
        React.createElement(LinkListItem, { href: '/warehouse/account/edit', icon: React.createElement(EditIcon, null), text: t('accountEdit'), onClick: onClick })));
};
export default WarehouseMenuList;
